import React from "react";
import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import { useSectionsData } from "../../utils/useSectionsData.ts";
import { getBrandName } from "../../utils/helpers.ts";
import glideImage from "../../utils/useGlideImage.ts";

export const HarvardStudy = () => {
  const sections = useSectionsData();
  const brandName = getBrandName();
  const staticContent = sections.pp_v7_static_content;
  const scientificStudies = sections.pp_v7_scientific_studies_section;
  const heading = scientificStudies?.tr_heading;
  const mainHeading = scientificStudies?.tr_main_heading;
  const description = scientificStudies?.tr_description;
  const referencies = scientificStudies?.references;

  return (
    <PageWrapper backgroundColor="section_white">
      <div className={s.study}>
        <div className={s.study__content}>
          <p className={s.study__subtitle}>{heading}</p>
          <img
            src={scientificStudies.university_logo}
            alt={brandName}
            width={179}
            height={48}
          />
          <p
            className={s.study__title}
            dangerouslySetInnerHTML={{ __html: mainHeading }}
          />
          <p
            className={s.study__text}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          {referencies && (
            <div className={s.study__reference}>
              {`${staticContent.tr_reference_label}:`}
              <ul>
                {referencies.map((item: { tr_text: string }, index: number) => (
                  <li
                    dangerouslySetInnerHTML={{ __html: item.tr_text }}
                    key={index}
                  />
                ))}
              </ul>
            </div>
          )}
        </div>
        <img
          className={s.study__lab}
          src={glideImage(scientificStudies.section_image, { w: 552, h: 552 })}
          alt={brandName}
          width={552}
          height={552}
        />
      </div>
    </PageWrapper>
  );
};
